import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import classnames from "classnames";
import { Title } from "../../components/NewTitle";
import { Link } from "react-router-dom";
// import { SilderDot } from "../../components/SilderDot";

export const HomeComment = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const commonList = [
    {
      common: `${t("page.other.item-one.common")}`,
      author: `—— ${t("page.other.item-one.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-dongnan.png",
      link: "/customer/southeast-university",
      alt: "东南大学单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-two.common")}`,
      author: `—— ${t("page.other.item-two.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
      link: "/customer/cnpn",
      alt: "中国石油单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-three.common")}`,
      author: `—— ${t("page.other.item-three.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-education.png",
      link: "/customer/hep",
      alt: "高教社单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-four.common")}`,
      author: `—— ${t("page.other.item-four.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-yuanqi.png",
      link: "/customer/yuanqi",
      alt: "元气森林单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-five.common")}`,
      author: `—— ${t("page.other.item-five.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-dazhong-new.png",
      link: "/customer/volkswagen",
      alt: "大众汽车单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-six.common")}`,
      author: `—— ${t("page.other.item-six.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-toyota.png",
      link: "/customer/toyota",
      alt: "丰田TOYOTA单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-seven.common")}`,
      author: `—— ${t("page.other.item-seven.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-jcdecaux.png",
      link: "/customer/jcdecaux",
      alt: "JCDecaux单点登录SSO-统一身份认证客户案例",
    },
    {
      common: `${t("page.other.item-eight.common")}`,
      author: `—— ${t("page.other.item-eight.author")}`,
      imgUrl: "//files.authing.co/authing-website/home-logo-coca-cola-v2.png",
      link: "/customer/coca-cola",
      alt: "可口可乐单点登录",
    },
  ];
  const commonIndexList = [
    { imgUrl: "//files.authing.co/authing-website/home-logo-dongnan.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-aws.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-education.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-zhijiang.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-kuangxin.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-toyota.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-jcdecaux.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-coca-cola-v2.png" },
  ];
  useInterval(() => {
    if (element < 8) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  }, 8000);
  const nextStep = () => {
    if (element < 8) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  };
  const lastStep = () => {
    if (element < 2) {
      setElement(8);
    } else {
      setElement(element - 1);
    }
  };
  const onMouseLeave = () => {};
  const SilderDot = () => {
    return (
      <div className={classnames("home-silder-dot-container")}>
        {commonIndexList?.map((item, index) => {
          return (
            <div key={`${item.url}-${index}`}>
              <div
                key={index}
                className={classnames("item-img", {
                  active: element - 1 === index,
                })}
                // onMouseEnter={() => setElement(index + 1)}
                // onMouseLeave={onMouseLeave}
              ></div>
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div className="home-common-block">
      <div className="inner">
        <section className="common-section">
          <Title title={t("page.other.title")} />
          <div className="common-warp">
            <div
              className="arrow-warp"
              onClick={lastStep}
              data-log="testimonial/arrowleft"
            >
              <div className="last-arrow">
                <i className="icon authing-icon authing-expand_less_black_24dp"></i>
              </div>
            </div>
            <div className="commonList-warp">
              {commonList.map((item, index) => {
                const cls = classnames({
                  common: true,
                  visible: element === index + 1,
                });
                return (
                  <div className={cls} key={`${item.imgUrl}-${index}`}>
                    <div className="text-box">
                      <div>
                        <div className="common-text">{item.common}</div>
                        {/* <div className="common-author">{item.author}</div> */}
                      </div>
                    </div>
                    <div className="imgUrl-box">
                      <div className="common-imgUrl">
                        <img src={item.imgUrl} alt={item.alt} />
                      </div>
                      {item.link ? (
                        <Link
                          className="common-link"
                          to={item.link}
                          data-log="testimonial/cases"
                        >
                          <span className="link">
                            {t("page.other.customer-detail")}
                          </span>
                          <span className="arrow">
                            <i className="icon authing-icon authing-arrow-right-line"></i>
                          </span>
                        </Link>
                      ) : (
                        <div className="common-link-default">
                          {t("page.other.customer-detail-default")}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {SilderDot()}
            </div>
            <div
              className="arrow-warp"
              onClick={nextStep}
              data-log="testimonial/arrowright"
            >
              <div className="next-arrow">
                <i className="icon authing-icon authing-expand_less_black_24dp"></i>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
